module.exports = __webpack_public_path__ + "img/layout_horizontal_icon.9bc679e7.svg";